import { isSlotAvailable } from '../base/model.mjs';

function useWithLabelProps(props, size) {
  const slotAvailable = isSlotAvailable(size);
  if (slotAvailable) {
    return props;
  }
  if (!("leftSlot" in props) && !("rightSlot" in props)) {
    return props;
  }
  if ("leftSlot" in props || "rightSlot" in props) {
    const entriesProps = Object.entries(props).filter(([key]) => {
      return key !== "leftSlot" && key !== "rightSlot";
    });
    const labelProps = Object.fromEntries(entriesProps);
    return labelProps;
  }
  return props;
}

export { useWithLabelProps as default };
//# sourceMappingURL=useWithLabelProps.mjs.map
